/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListInvitationsQueryResponse,
  ListInvitationsQueryParams,
} from '../types/ListInvitations'

function getListInvitationsUrl() {
  const res = { method: 'GET', url: `/api/v1/invitations/` as const }
  return res
}

/**
 * @description List invitations with optional search filter and pagination.
 * @summary List company invitations
 * {@link /api/v1/invitations/}
 */
export async function listInvitations(
  params?: ListInvitationsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListInvitationsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListInvitationsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
